export default "__VITE_ASSET__EPU3zgHl__"